// 这是检测当前文章页是否被内嵌在iframe并支持spm上报的代码
const isInIframe = () => {
    try {
        return window.self !== window.top
    } catch (e) {
        return false
    }
}
const isFromSohu = () => {
    try {
        return window?.top?.location?.href.includes('sohu.com')
    } catch (error) {
        return false
    }
}
const parentURL = () => {
    try {
        return window?.parent?.location?.href
    } catch (error) {
        return ''
    }
}
const setDataSpmExt = () => {
    if (isInIframe()) {
        const isSohu = isFromSohu() ? 1 : 0
        const ext = isSohu
            ? `iframe:1;fromSohu:${isSohu};parentURL:${parentURL()}`
            : `iframe:1;fromSohu:${isSohu}`
        document.body.setAttribute('data-spm-ext', ext)
    }
}
setDataSpmExt()